import { useEffect, useState } from "react";

export function proposalExpired(
  status: string,
  expiresAt: string | null | undefined,
  now: number,
): boolean {
  return (
    status === "pending" && Boolean(expiresAt) && Date.parse(expiresAt!) <= now
  );
}

/** Server deadlines only. Wake again after browser suspension or reconnect. */
export function useProposalDeadlineClock(
  deadlines: readonly (string | null | undefined)[],
  wakeKey?: unknown,
): number {
  const [now, setNow] = useState(Date.now);
  const key = deadlines.filter(Boolean).join("|");
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const refresh = () => {
      clearTimeout(timer);
      const current = Date.now();
      setNow(current);
      const next = key
        .split("|")
        .map(Date.parse)
        .filter((value) => Number.isFinite(value) && value > current)
        .sort((a, b) => a - b)[0];
      if (next !== undefined)
        timer = setTimeout(refresh, Math.min(next - current, 2_147_483_647));
    };
    refresh();
    for (const event of ["focus", "online", "pageshow"])
      window.addEventListener(event, refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      clearTimeout(timer);
      for (const event of ["focus", "online", "pageshow"])
        window.removeEventListener(event, refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [key, wakeKey]);
  return now;
}
